module.exports = __webpack_public_path__ + "static/img/fc.f03b810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fc.png
// module id = wvm8
// module chunks = 1